
    import '/mnt/src/components/Tag/index.md?watch=parent';
    export const demoIndex = {
  ids: ["tag-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Tag/index.md?type=demo')
};